module.exports = __webpack_public_path__ + "static/media/img2-1.3271663f.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/limon/nutricheck_foliar/FE/img2-1.png
// module id = 1649
// module chunks = 3